import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Shield, Zap } from "lucide-react";
import { Button } from "../ui/button";
import HeroImg from "../../img/HeroImg.png";

export default function Hero() {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - offset,
        behavior: "smooth"
      });
    }
  };

  return (
    <div className="relative min-h-screen flex items-center overflow-hidden bg-[#0B1C2C]">
      {/* Blueprint grid background */}
      <div className="absolute inset-0 opacity-5">
        <div 
          className="absolute inset-0" 
          style={{
            backgroundImage: `
              linear-gradient(#24A19C 1px, transparent 1px),
              linear-gradient(90deg, #24A19C 1px, transparent 1px)
            `,
            backgroundSize: '50px 50px'
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-6 py-32 relative z-10 w-full">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="inline-flex items-center gap-2 bg-[#24A19C]/10 border border-[#24A19C]/30 rounded-full px-4 py-2 mb-6"
            >
              <Shield className="w-4 h-4 text-[#24A19C]" />
              <span className="text-sm font-medium text-[#24A19C]">Defence Technology Capital</span>
            </motion.div>

            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Growth capital for defence technology{" "}
              <span className="text-[#24A19C]">leaders</span>
            </h1>

            <p className="text-xl text-[#6B7C93] mb-8 leading-relaxed">
              We invest growth capital in fast-growing MilTech firms creating mission-critical, dual-use and military solutions . Every product we back is combat-approved and built to perform under real-world conditions. We support high-potential startups and established businesses to scale faster, bolstering Europe’s rearmament and the protection of nations at risk.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={() => scrollToSection("contact")}
                className="bg-[#24A19C] hover:bg-[#1d8a85] text-white px-8 py-6 text-lg rounded-lg font-medium transition-all duration-200 hover:shadow-xl hover:shadow-[#24A19C]/20"
              >
                Investors
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
              <Button 
                onClick={() => scrollToSection("contact")}
                variant="outline"
                className="border-2 border-[#24A19C] text-[#24A19C] hover:bg-[#24A19C] hover:text-white px-8 py-6 text-lg rounded-lg font-medium transition-all duration-200"
              >
                Companies — Submit Opportunity
              </Button>
            </div>

            <div className="mt-12 grid grid-cols-3 gap-6">
              <div>
                <div className="text-3xl font-bold text-[#E0B422] mb-1">120+</div>
                <div className="text-sm text-[#6B7C93]">Years Combined Experience</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-[#E0B422] mb-1">€1.6T</div>
                <div className="text-sm text-[#6B7C93]">NATO 2025 Defence Spend</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-[#E0B422] mb-1">≥3.5%</div>
                <div className="text-sm text-[#6B7C93]">Target GDP by 2035</div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="flex justify-center"
          >
            <div className="relative">
              <img src={HeroImg} alt="Hero Image" className="w-full h-auto max-w-[520px] object-contain rounded-2xl" />
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}